import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DocumentPreview from "./DocumentPreview";

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        "& > div": {
            marginRight: 15
        }
    }
}));

const DocumentList = ({ files, deleteOrg, editmode }) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            {files && files.map((file, idx) => (
                <DocumentPreview key={`OrgDocumentPreview${idx}`} editmode={editmode} file={file} onItemDelete={deleteOrg} />
            ))}
        </div>
    );
};

export default DocumentList;
